module.exports = __webpack_public_path__ + "static/img/10.adbca8d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/eng/10.png
// module id = 5Qzu
// module chunks = 0